<template>
  <validation-observer :ref="validObserver" v-slot="{invalid}" slim>
    <g-popup :title="$t('pages_user_UserCreateAccount.editAuth')" :show="true" :instKey="instKey" :background-click="false">
      <template #body>
          <div class="-font-size-12">

            <div class="-label -width-100 -mt-5">
              <div class="-wrapper">
                <p class="-text">{{$t('common.account_group')}}</p>
              </div>
              <div class="-wrapper">
                <div class="-splitted-wrap -width-100">
                  <g-dropdown
                    id="customer-info-auth"
                    dropdown-type="button"
                    variant="secondary"
                    text-align="start"
                    class="-width-100"
                    v-model="updateUserInfo.auth"
                    :invalid="invalid"
                    :disabled="!isBespinAdmin && isMe">
                    <g-dropdown-item-wrap
                      v-if="!isBespinAdmin && isMe"
                    >
                      <g-dropdown-item
                        :key="userDetail.group.key"
                        :text="userDetail.group.name"
                        :value="userDetail.group.id"/>
                    </g-dropdown-item-wrap>
                    
                    <g-dropdown-item-wrap
                      v-else
                    >
                      <g-dropdown-item
                        v-show="group.id != 'AM'"
                        v-for="group in groupList"
                        :key="group.key"
                        :text="group.name"
                        :value="group.id"/>
                    </g-dropdown-item-wrap>

                  </g-dropdown>
                </div>
              </div>
            </div>
            <div class="-label -width-100 -mt-5" v-if="isBespinMiddleManager">
              <div class="-wrapper -mb-2">
                <p class="-text">{{$t('common.middle_group')}}</p>
              </div>
              <div class="-wrapper">
                <div class="-splitted-wrap -width-100">
                  <g-dropdown
                    id="customer-info-leader"
                    dropdown-type="button"
                    variant="secondary"
                    text-align="start"
                    class="-width-100"
                    v-model="updateUserInfo.leader"
                    :invalid="invalid"
                    :disabled="!isBespinAdmin && isMe">
                    <g-dropdown-item-wrap>
                      <g-dropdown-item
                        v-for="group in middleGroupList"
                        :key="group.codeId"
                        :text="group.codeName"
                        :value="group.codeId"/>
                    </g-dropdown-item-wrap>
                  </g-dropdown>
                </div>
              </div>
            </div>
            
          </div>
      </template>
      <template #footer>
        <g-button
          id="customer-info-save"
          variant="primary"
            class="-mr-0"
            :text="$t('common.save')"
            :disabled="invalid"
            @click="onClickSave">
          <span>{{$t('common.save')}}</span>
        </g-button>
      </template>
    </g-popup>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import CodeUpdate from '../../../code/CodeUpdate'
import {AUTH_GROUP} from "@/constants/constants";
import {TEL_CODES} from "@/constants/constants";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    instKey: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      validObserver: null,
      telCodes: TEL_CODES,
      updateUserInfo: {
        userId: null,
        userEmail: null,
        auth: null,
        leader: null
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'userInfo',
      'userDetail',
      'codeUserUpdate',
      'userErrorMessage'
    ]),
    ...mapGetters('customer', ['groupList']),
    ...mapGetters('code', ['snsList', 'middleGroupList']),
    isBespinAdmin () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    },
    isBespinMiddleManager () {
      return this.updateUserInfo.auth === AUTH_GROUP.BespinMiddleManager
    },
    isMe () {
      return this.userInfo.userId === this.updateUserInfo.userId
    },
    snsValueList () {
      return this.snsList.map(item => item.codeId).filter(item => item !== 'CH')
    }
  },
  methods: {
    ...mapActions('user', ['updateUser', 'getUserDetail']),
    getSnsName (snsId) {
      return (this.snsList.find(item => item.codeId === snsId) || {}).codeName
    },
    onClickSave () {
      this.updateUser(this.updateUserInfo)
    },
    isLastNameFirst(){
      return this.locale != 'en';
    }
  },
  watch: {
    codeUserUpdate (value) {
      if (value === CodeUpdate.SUCCESS) {
        this.$showToast(this.$t('pages_user_components_CustomerInfoChangeInfo.modify_user'))
        this.$popupManager.close(this.instKey)
      } else if (value === CodeUpdate.ERROR) {
        this.$showToast(this.$t('user.error'))
      }
    },
    updateUserInfo: {
      handler () {
      
      },
      deep: true
    }
  },
  mounted () {
    this.updateUserInfo = {
      userId: this.userDetail.userId,
      userEmail: this.userDetail.userEmail,
      auth: this.userDetail.auth,
      leader: this.userDetail.leader
    }
  }
}

</script>

<style>

.fullWidthButton {
  height:32px !important;
}
.fullWidthButton > span:first-child {
  width:100% !important;
}
.halfWithButton {
  width:95% !important;
  height:32px !important;
}

.halfWithButton > span:first-child {
  width:100% !important;
}

.-width-95{
  width:95% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/components/UserInfoChange.vue